import classNames from 'classnames'
import { _x } from '@wordpress/i18n'

function LayoutToggle(props: {
  variant: 'desktop' | 'mobile'
  value: 'card' | 'list'
  onChange: (value: 'card' | 'list') => void
}) {
  const buttonClassNames = classNames(
    'btn btn-sm filter-panel-button',
    props.variant === 'desktop' &&
      'btn-square icon-text-hidden--mobile btn-outline-default'
  )

  return (
    <button
      type="button"
      className={buttonClassNames}
      onClick={() => props.onChange(props.value === 'card' ? 'list' : 'card')}
      aria-label={
        props.value === 'card'
          ? _x('Display as list', 'Layout Toggle Aria Label', 'icf')
          : _x('Display as cards', 'Layout Toggle Aria Label', 'icf')
      }
    >
      <i className={`icon ${props.value === 'card' ? 'fa-list' : 'fa-grid'}`} />
      {props.variant === 'mobile' && (
        <span>
          {props.value === 'card'
            ? _x('List', 'Layout Toggle Label', 'icf')
            : _x('Cards', 'Layout Toggle Label', 'icf')}
        </span>
      )}
    </button>
  )
}

export default LayoutToggle
